import {ChangeDetectorRef, Component, HostListener, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MatBottomSheet} from "@angular/material/bottom-sheet";
import {
  EquityInstallmentDocumentsPanelComponent
} from "./equity-installment-subcomponents/equity-installment-documents-panel/equity-installment-documents-panel.component";
import {Apollo} from "apollo-angular";
import {get_equity_installments} from "./graphql/getEquityInstallments";
import {ActivatedRoute} from "@angular/router";
import {EquityInstallmentService} from "./equity-installment.service";
import {
  EquityInstallmentSharepointService
} from "./equity-installment-subcomponents/equity-installment-documents-panel/equity-installment-sharepoint.service";
import {MatDrawer} from "@angular/material/sidenav";

@Component({
    selector: 'app-equity-installment',
    templateUrl: './equity-installment.component.html',
    styleUrls: ['./equity-installment.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})


export class EquityInstallmentComponent implements OnInit{

  public innerWidth:any;
  public isSmallerScreen:boolean = false;
  public projectId:string | null;
  public bottomPanelExpanded:boolean = true;
  @ViewChild('drawer') drawer: MatDrawer

  constructor(private _bottomDrawer: MatBottomSheet, public equityService: EquityInstallmentService, private chdRef:ChangeDetectorRef) {
  }
  @HostListener('window:resize', ['$event'])
  onResize(event:any) {
    this.innerWidth = window.innerWidth
    this.isSmallerScreen = this.innerWidth < 900;
    if(this.bottomPanelExpanded && this.isSmallerScreen){
      this.openBottomPanel()
    }
    if(this.bottomPanelExpanded && !this.isSmallerScreen){
      this.openBottomPanel()
    }
  }

  ngOnInit() {
    this.innerWidth = window.innerWidth
    this.isSmallerScreen = this.innerWidth < 900;
    if(this.bottomPanelExpanded && this.isSmallerScreen){
      this.openBottomDrawer()
    }

  }

  public openBottomDrawer(){
    let ref = this._bottomDrawer.open(EquityInstallmentDocumentsPanelComponent, {
      hasBackdrop: false,
      panelClass: 'panel-width',
      data: {
        isSmallerScreen: true
      }
    })

    ref.afterDismissed().subscribe((g:any) => this.bottomPanelExpanded = false)
  }

  public openBottomPanel(){
    this.bottomPanelExpanded = !this.bottomPanelExpanded
    if(this.bottomPanelExpanded){
      this.openBottomDrawer()
    } else {
      this._bottomDrawer.dismiss()
    }
  }


  public openPanel(){
    if(this.isSmallerScreen){
      this.openBottomPanel()
    } else {
      this.drawer.open()
    }
  }
}
